import React from 'react';
import ReactOnRails from 'react-on-rails';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  HashRouter
} from 'react-router-dom';
import { Provider } from 'react-redux';
import store from '../store';

import {
  setPage,
  setPages,
  setUser,
  setTerritory,
  setMarket,
  setAffiliate,
  setEnvironment,
  setLanguageOptions,
  setEthnicityOptions,
  setContent,
  setTerms,
  setRegistered,
  setReferralProgram,
  setActiveProfileElements,
  setProfileElements,
  setRequiredFields,
  setResidentVaccinationOptions,
  setLocalProfileElements,
  setResidents,
  invalidateResidents,
  invalidateRooms,
  fetchRoomsIfNeeded,
  invalidatePhotos,
  invalidateHost,
  setAddress
} from '../actions';
import {
  setAuthenticatedUser,
  setRecaptchaSiteId,
  setVaccinationMandatory
} from '../../../shared/actions'
import { IntlProvider } from 'react-intl';
import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import fr from 'react-intl/locale-data/fr';
import { translations } from '../../../libs/i18n/translations';
import { defaultLocale } from '../../../libs/i18n/default';
import Routes from '../routes/routes';
import Layout from "../layout/Layout";
import Register from "../components/containers/Register";
import { FeatureProvider } from "../../../shared/components/FeatureContext";

const locale = defaultLocale;
const messages = translations[locale];
const dispatch = store.dispatch


addLocaleData([...en, ...fr]);

class HostSignUp extends React.Component {
  constructor(props) {
    super(props)
    dispatch(setAddress(props.address))

    dispatch(
      setUser(props.user)
    );

    dispatch(
      setTerritory(props.territory)
    );

    dispatch(
      setMarket(props.market)
    );

    dispatch(
      setEnvironment(props.environment)
    );

    dispatch(
      setAffiliate(props.affiliate)
    );

    dispatch(
      setReferralProgram(props.referral_program)
    );

    dispatch(
      setLanguageOptions(props.language_options)
    );

    dispatch(
      setEthnicityOptions(props.ethnicity_options)
    );

    dispatch(
      setActiveProfileElements(props.active_profile_elements)
    );

    dispatch(
      setTerms(props.terms)
    );

    dispatch(
      setRegistered(props.registered)
    );

    dispatch(invalidateHost());
    dispatch(invalidatePhotos());
    dispatch(invalidateResidents());
    dispatch(invalidateRooms());

    dispatch(
      setPage(props.page)
    );

    dispatch(
      setProfileElements(props.profile_elements)
    );

    dispatch(
      setRequiredFields(props.required_fields)
    )

    dispatch(setVaccinationMandatory(props.vaccination_mandatory))

    dispatch(
      setResidentVaccinationOptions(props.resident_vaccination_options)
    )

    dispatch(setRecaptchaSiteId(props.recaptcha_site_id))

    dispatch(
      setLocalProfileElements(props.local_profile_elements)
    )

    dispatch(
      setContent(props.content)
    );

    dispatch(
      setPages(props.pages)
    );

    dispatch(
      setAuthenticatedUser(props.authenticated_user)
    )
  }
  render() {
    return (
      <Provider store={store}>
        <FeatureProvider>
          <Layout user={this.props.user} territory={this.props.territory} page={this.props.page}>
            <HashRouter>
              {Routes}
            </HashRouter>
          </Layout>
        </FeatureProvider>
      </Provider>
    );
  }
}

export default HostSignUp;
